import { Box } from '@wishket/design-system';
import { PropsWithChildren } from 'react';

const ListItem = ({ children }: PropsWithChildren) => {
  return (
    <Box className="flex gap-3 desktop:items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="4"
        viewBox="0 0 4 4"
        fill="none"
        className="mt-3 desktop:mt-0"
      >
        <circle cx="2" cy="2.00012" r="2" fill="currentColor" />
      </svg>
      <Box className="flex flex-col gap-2 desktop:flex-row desktop:items-center desktop:gap-3">
        {children}
      </Box>
    </Box>
  );
};

export default ListItem;
